export function formattedCents(cents: number): string {
  const dollars = cents / 100
  const isWholeDollar = cents % 100 === 0
  if (isWholeDollar) {
    return `$${dollars.toLocaleString("en-US")}`
  } else {
    return `$${dollars.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }
}

export function moneyInputSanitize(numberIn: string): string {
  let number = numberIn

  number = `${number}`
  // eslint-disable-next-line prefer-const
  let [dollars, cents] = number
    .toString()
    .replace(/[^\d.]/g, "")
    .split(".")

  if (/^0+$/.test(dollars)) {
    dollars = "0"
  } else if (dollars.length > 1) {
    // Trim extra leading zeros ('02' becomes '2')
    dollars = dollars.replace(/^0+/, "")
  } else if (dollars.length === 0 && typeof cents !== "undefined") {
    // Add leading zero when cents are present ('.' becomes '0.')
    dollars = "0"
  }

  if (typeof cents === "undefined") {
    // There was no '.'
    return dollars
  } else {
    // '.' was anywhere
    return [dollars, cents.slice(0, 2)].join(".")
  }
}
